import { useUnitJourneyContext } from "@/hooks/useUnitJourneyContext";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";
import { RentButton } from "@/components/units/action/RentButton";
import { ReserveButton } from "@/components/units/action/ReserveButton";
import { QuoteButton } from "@/components/units/action/QuoteButton";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { useRentalAction } from "@/hooks/useRentalAction";
import { useReservationAction } from "@/hooks/useReservationAction";
import { useTriggerButtonVisibility } from "@/hooks/useTriggerButtonVisibility";

export const UnitCheckout = () => {
    const { selectedUnitId } = useUnitJourneyContext();
    const { unitGroup } = useUnitItemContext();
    const { openRentalFunnel, label: rentLabel } = useRentalAction(
        unitGroup.representative_unit.id,
    );
    const { openReservationFunnel, label: reserveLabel } = useReservationAction(
        unitGroup.representative_unit.id,
    );
    const { canReserve, canSoftReserve, canRent } =
        useTriggerButtonVisibility();

    return (
        <div className="unit-checkout tw:flex-1 tw:overflow-y-auto tw:py-4">
            {canRent && (
                <Card>
                    <CardHeader>
                        <CardTitle>Rent Your Unit</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <ul className="tw:list-disc">
                            <li>Move in as soon as today.</li>
                            <li>Simple online rental process.</li>
                        </ul>
                        <RentButton
                            handleRentalClick={openRentalFunnel}
                            label={rentLabel}
                        />
                    </CardContent>
                </Card>
            )}
            {canReserve && (
                <Card>
                    <CardHeader>
                        <CardTitle>Reserve Your Unit</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <ul className="tw:list-disc">
                            <li>Move in when you're ready.</li>
                            <li>No obligation to rent.</li>
                        </ul>
                        <ReserveButton
                            label={reserveLabel}
                            onReservationClick={openReservationFunnel}
                        />
                    </CardContent>
                </Card>
            )}
            {canSoftReserve && (
                <Card>
                    <CardHeader>
                        <CardTitle>Get a Quote</CardTitle>
                        <CardDescription>Secure your rate.</CardDescription>
                    </CardHeader>
                    <CardContent>
                        <div>
                            Quote and special can expire after 7 days. Can be
                            converted to a rental or reservation.
                        </div>
                        <QuoteButton unitId={selectedUnitId} />
                    </CardContent>
                </Card>
            )}
        </div>
    );
};
